import { split, find, includes, replace, nth, invoke } from 'lodash';

export function getNonce() {
    const cspHeader = document.querySelector("meta[http-equiv='Content-Security-Policy']");
    const cspHeaderContent = invoke(cspHeader, 'getAttribute', 'content');
    const scriptSrcDirective = find(split(cspHeaderContent, ';'), directive => includes(directive, 'script-src'));
    return nth(
        split(
            replace(
                find(split(scriptSrcDirective, ' '), s => includes(s, 'nonce')),
                /'/g,
                ''
            ),
            '-'
        ),
        1
    );
}



// WEBPACK FOOTER //
// ./src/utils/get-nonce.js